// The public, brandable base URL used for shareable links (submissions, demos, showcase).
// Falls back to the current origin when not configured.
export function publicOrigin() {
  const configured = process.env.REACT_APP_PUBLIC_URL;
  if (configured) return configured.replace(/\/+$/, "");
  if (typeof window !== "undefined") return window.location.origin;
  return "";
}
